// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown_folder_list-module__empty--3Wino{padding:16px}.dropdown_folder_list-module__subtitle--1vkv9{padding:16px 16px 4px;font-weight:400;font-size:12px;line-height:18px;letter-spacing:0;color:#303030}\n", ""]);
// Exports
exports.locals = {
	"empty": "dropdown_folder_list-module__empty--3Wino",
	"subtitle": "dropdown_folder_list-module__subtitle--1vkv9"
};
module.exports = exports;
